import { render, staticRenderFns } from "./arrow-left-right-buttons.vue?vue&type=template&id=25500fc6&"
import script from "./arrow-left-right-buttons.vue?vue&type=script&lang=js&"
export * from "./arrow-left-right-buttons.vue?vue&type=script&lang=js&"
import style0 from "./arrow-left-right-buttons.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports